import { render, staticRenderFns } from "./NewTrade.vue?vue&type=template&id=8582ab04"
import script from "./NewTrade.vue?vue&type=script&lang=js"
export * from "./NewTrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports